import * as React from 'react';



export default class ErrorCircle extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="icons/error/white" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g>
                <circle id="Oval-7" stroke="#FFFFFF" cx="8" cy="8" r="7.5"></circle>
                <text id="!" fontFamily="ProximaNova-Medium, Proxima Nova" fontSize="12" fontWeight="400" fill="#FFFFFF">
                    <tspan x="7.072" y="12">!</tspan>
                </text>
            </g>
        </g>
      </svg>
    )
  }
}
